import { c as _c } from "react/compiler-runtime";
import AlertComponent, { AlertType } from '@spa/components/alert/alert.component';
import { ReactElement, memo } from 'react';
import { FormatMessageFunction } from '@spa/lib/i18n/common/FormatMessageFunction';
import { NewsletterStatus } from '@spa/generated/graphql/graphql';
import { getNewsletterRegistrationErrorKey } from '@spa/lib/newsletter/newsletterRegistrationStatus';
interface Props {
  readonly formatMessage: FormatMessageFunction;
  readonly submissionError: NewsletterStatus | null;
  readonly successResponseOverride?: ReactElement;
}
const getNewsletterRegistrationAlertType = (erroredStatus: NewsletterStatus | null): AlertType => {
  let alertType: AlertType;
  if (erroredStatus === NewsletterStatus.WERBESPERRUNG) {
    alertType = AlertType.WARNING;
  } else if (erroredStatus) {
    alertType = AlertType.ERROR;
  } else {
    alertType = AlertType.SUCCESS;
  }
  return alertType;
};
function NewsletterRegistrationAlert(t0) {
  const $ = _c(21);
  const {
    formatMessage,
    submissionError,
    successResponseOverride
  } = t0;
  let alertContent;
  if (submissionError === NewsletterStatus.WERBESPERRUNG) {
    let t1;
    if ($[0] !== formatMessage) {
      t1 = formatMessage("werbesperrungError");
      $[0] = formatMessage;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <strong>{t1}</strong>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <br />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== formatMessage) {
      t4 = formatMessage("werbesperrungErrorBody");
      $[5] = formatMessage;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== t2 || $[8] !== t4) {
      t5 = <>{t2}{t3}{t4}</>;
      $[7] = t2;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    alertContent = t5;
  } else {
    if (submissionError) {
      let t1;
      if ($[10] !== formatMessage || $[11] !== submissionError) {
        t1 = formatMessage(getNewsletterRegistrationErrorKey(submissionError));
        $[10] = formatMessage;
        $[11] = submissionError;
        $[12] = t1;
      } else {
        t1 = $[12];
      }
      alertContent = t1;
    } else {
      let t1;
      if ($[13] !== formatMessage || $[14] !== successResponseOverride) {
        t1 = successResponseOverride ?? formatMessage("registerSuccess");
        $[13] = formatMessage;
        $[14] = successResponseOverride;
        $[15] = t1;
      } else {
        t1 = $[15];
      }
      alertContent = t1;
    }
  }
  let t1;
  if ($[16] !== submissionError) {
    t1 = getNewsletterRegistrationAlertType(submissionError);
    $[16] = submissionError;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  let t2;
  if ($[18] !== alertContent || $[19] !== t1) {
    t2 = <AlertComponent alertType={t1} hideIcon={false} content={alertContent} />;
    $[18] = alertContent;
    $[19] = t1;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  return t2;
}
export default memo(NewsletterRegistrationAlert);